import { useEffect } from "react";
import { discardQueuedIframeActivity, logIframeActivity } from "src/helpers/iframeActivity";

/**
 * Records when a custom app is opened. Activity inside the iframe comes from its own tracker.
 */
export function useCustomAppActivityTracker({ content, iframeRef }) {
  const src = content?.custom_app_url;
  const name = content?.page_name;

  useEffect(() => {
    const iframe = iframeRef?.current;
    if (!src || !iframe) return;

    let loaded = false;
    const handleLoad = () => { loaded = true; };
    iframe.addEventListener("load", handleLoad);
    const openRecord = logIframeActivity({ action: "OPEN", summary: `Opened "${name}"`, details: { url: src }, iframe });

    return () => {
      iframe.removeEventListener("load", handleLoad);
      if (!loaded) discardQueuedIframeActivity(openRecord);
    };
  }, [src, name, iframeRef]);
}
